<script>
  import { getContext } from 'svelte';
	import { fly } from 'svelte/transition';
	
	import Popup from './Popup.svelte';
	
	export let content;

  const { open } = getContext('simple-modal');
	
	let opening = false;
	let opened = false;
	let closing = false;
	let closed = false;

  const showPopup = () => {
		open(Popup, { message: content });
	};
	
	
	let name;
	let status = 0;
	
	const onCancel = (text) => {
		name = '';
		status = -1;
	}
	
	const onOkay = (text) => {
		name = text;
		status = 1;
	}
</script>

<button on:click={showPopup} class="text-xl lg:text-white"><i class="fal fa-info-circle"></i></button>